import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function LogoutPage() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    (async () => {
      await logout();
      navigate("/login", { replace: true });
    })();
  }, [logout, navigate]);
  return (
    <div className="min-h-screen flex items-center justify-center text-neutral-500" data-testid="logout-page">
      Signing out…
    </div>
  );
}
